<footer class="text-primary ptb-25" id="footer">
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-3 text-center mrb-5 mrb-md-0">
        <div class="compony-logo mrb-10">
          <img
            class="w-100 max-150"
            src="{{ global?.setting?.logo }}"
            alt="compony logo"
          />
        </div>
        <div class="social-icon mrtb-10 d-flex justify-content-around">
          <a
            class="social-icon-item mre-6 bg-gray2 rounded-circle width-30 height-30 d-flex justify-content-center align-items-center"
            href="tel:{{ global?.setting?.mobile }}"
          >
            <img
              class="w-100 max-10 align-baseline"
              src="../../../../assets/images/whatsapp-blue.svg"
              alt="social icon"
            />
          </a>
          <a
            class="social-icon-item mre-6 bg-gray2 rounded-circle width-30 height-30 d-flex justify-content-center align-items-center"
            href="{{ global?.setting?.snapchat }}"
            ><img
              class="height-15 width-15 align-baseline"
              src="../../../../assets/images/logo-snapchat.svg"
              alt="social icon"
          /></a>
          <a
            class="social-icon-item mre-6 bg-gray2 rounded-circle width-30 height-30 d-flex justify-content-center align-items-center"
            href="{{ global?.setting?.linkedIn }}"
            ><img
              class="height-15 width-15 align-baseline"
              src="../../../../assets/images/logo-linkedIn.svg"
              alt="social icon"
          /></a>
          <a
            class="social-icon-item mre-6 bg-gray2 rounded-circle width-30 height-30 d-flex justify-content-center align-items-center"
            href="{{ global?.setting?.facebook }}"
            ><img
              class="height-15 width-15 align-baseline"
              src="../../../../assets/images/logo-facebook.svg"
              alt="social icon"
          /></a>
          <a
            class="social-icon-item mre-6 bg-gray2 rounded-circle width-30 height-30 d-flex justify-content-center align-items-center"
            href="{{ global?.setting?.twitter }}"
            ><img
              class="height-15 width-15 align-baseline"
              src="../../../../assets/images/logo-twitter.svg"
              alt="social icon"
          /></a>
          <a
            class="social-icon-item mre-6 bg-gray2 rounded-circle width-30 height-30 d-flex justify-content-center align-items-center"
            href="{{ global?.setting?.instagram }}"
            ><img
              class="height-15 width-15 align-baseline"
              src="../../../../assets/images/logo-intgram.svg"
              alt="social icon"
          /></a>
        </div>
        <div class="stores d-flex justify-content-around">
          <img
            src="../../../../assets/images/google-play-img.svg"
            alt="google play"
          />
          <img
            src="../../../../assets/images/app-store-img.svg"
            alt="app store"
          />
        </div>
      </div>
      <div class="col-12 col-md-4 ps-lg-15 size-2 mrb-5 mrb-md-0">
        <div class="row">
          <div class="col-6 col-md-6 mrtb-15 mrtb-md-0">
            <div class="footer-title size-5 weight-700">
              {{ "footer.importantLinks" | translate }}
            </div>
            <div class="col-6 col-md-6 footer-links w-100">
              <a
                routerLink="/"
                class="footer-item d-block cursor-pointer size-2 weight-600 mrtb-8"
                >{{ "footer.home" | translate }}</a
              >
              <!-- <a
                routerLink="doctor"
                class="footer-item d-block cursor-pointer size-2 weight-600 mrb-8"
                >{{ "footer.doctors" | translate }}</a
              > -->
              <a
                routerLink="session"
                class="footer-item d-block cursor-pointer size-2 weight-600 mrb-8"
                >{{ "footer.offers" | translate }}</a
              >
              <!-- <a routerLink="membership" class="footer-item d-block cursor-pointer size-2 weight-600 mrb-8">{{ 'footer.memberships' | translate }}</a> -->
              <!-- <a
                routerLink="join-us"
                class="footer-item d-block cursor-pointer size-2 weight-600 mrb-8"
                >{{ "footer.jobs" | translate }}</a
              > -->
              <a
                routerLink="terms-and-conditions"
                class="footer-item d-block cursor-pointer size-2 weight-600 mrb-8"
                >{{ "footer.terms" | translate }}</a
              >
            </div>
          </div>
          <div class="col-6 col-md-6 mrtb-15 mrtb-md-0">
            <div class="footer-title size-5 weight-700">
              {{ "footer.services" | translate }}
            </div>
            <div class="col-6 col-md-6 footer-links w-100">
              <a
                [routerLink]="['/service', service?.serviceId]"
                class="footer-item d-block cursor-pointer size-2 weight-600 mrtb-8"
                *ngFor="let service of global.services"
                >{{ service.name || service.nameAr }}</a
              >
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-5 overflow-hidden">
        <div class="footer-title size-5 weight-700">
          {{ "footer.contactInformation" | translate }}
        </div>
        <div class="mrtb-8 d-flex align-items-center">
          <div
            class="icon bg-primary width-30 height-30 d-flex justify-content-center align-items-center rounded-circle mre-5"
          >
            <img
              class="height-15 width-15"
              src="../../../../assets/images/icon-location-white.svg"
              alt="icon"
            />
          </div>
          <div
            class="size-2 weight-600 w-100 max-350"
            [innerHTML]="global?.setting?.address || global?.setting?.addressAr"
          ></div>
        </div>
        <div class="mrtb-8 d-flex align-items-center">
          <div
            class="icon bg-primary width-30 height-30 d-flex justify-content-center align-items-center rounded-circle mre-5"
          >
            <img
              class="height-15 width-15"
              src="../../../../assets/images/iocon-mail-white.svg"
              alt="icon"
            />
          </div>
          <div>{{ global?.setting?.email }}</div>
        </div>
        <div class="mrtb-8 d-flex align-items-center">
          <div
            class="icon bg-primary width-30 height-30 d-flex justify-content-center align-items-center rounded-circle mre-5"
          >
            <img
              class="height-15 width-15"
              src="../../../../assets/images/icon-clock.svg"
              alt="icon"
            />
          </div>
          <div>
            <div class="size-2 weight-700 mrb-5">
              {{ "footer.workingHours" | translate }}
            </div>
            <div
              class="size-2 weight-600"
              [innerHTML]="global?.setting?.workingHoursAr"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="copywrite d-md-flex justify-content-center text-center border-top pt-5 mrt-10 size-4 weight-600"
    >
      {{ "footer.copyWrite" | translate }} {{ year }}
      <div class="mrs-10 d-flex">
        <img
          class="mre-2"
          src="../../../assets/images/hearta-aa.svg"
          alt="icon"
        />{{ "footer.designBy" | translate }}
        <a class="mrs-2 weight-700" href="http://baianat.com/">{{
          "footer.baianat" | translate
        }}</a>
      </div>
    </div>
  </div>
</footer>
